import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopNav from "../../../components/TopNav";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import DocumentTable from "./DocumentTable";
import { getUserDocuments } from "../../../actions/document.action";

export default function DocumentTracking() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserDocuments());
  }, []);

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    document: { userDocumentProcessingLoading, userDocumentProcessingList },
  } = useSelector(({ documentReducer }) => ({ document: documentReducer }));

  const loadState =
    profile.userProfileLoading === Loading.FETCHING ||
    userDocumentProcessingLoading === Loading.FETCHING;

  return (
    <>
      <div className="overflow-hidden">
        <div className=" doc_processing_color h-44 px-2 pt-3">
          <TopNav link={"/dashboard/user/document-processing"} />
          <div className="transcript_header">Document Tracking</div>
          <div className="text-md md:text-lg md:w-2/3">
            Track your Certificate, Transcript, English Waiver etc.
          </div>
        </div>
      </div>

      {loadState ? (
        <RoundLoader />
      ) : (
        <div>
          <>
            <div className="bg-white px-2 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="font-bold md:text-lg md:w-2/3">
                Please note that each request takes 5 working days after payment
                and confirmation of all documentation provided.
              </div>

              <div className="">
                <DocumentTable
                  list={userDocumentProcessingList}
                  // handleCreate={() => setOpen(true)}
                />
              </div>
            </div>
          </>
        </div>
      )}
    </>
  );
}
